import { createAction, props } from '@ngrx/store';

export const NameOmniChange = createAction(
  '[OMNI CONFIGURATION]: Name Omni Changed',
  props<{ nameOmni: string }>(),
);

export const StatusOmniChange = createAction(
  '[OMNI CONFIGURATION]: Status Omni Changed',
  props<{ isActiveOmni: boolean }>(),
);

export const SmsSenderOmniChange = createAction(
  '[OMNI CONFIGURATION]: SMS Sender Omni Changed',
  props<{ smsSenderOmni: string }>(),
);

export const ViberSenderOmniChange = createAction(
  '[OMNI CONFIGURATION]: Viber Sender Omni Changed',
  props<{ viberSenderOmni: string }>(),
);

export const AccountIdOmniChange = createAction(
  '[OMNI CONFIGURATION]: Account ID Omni Changed',
  props<{ accountIdOmni: string }>(),
);

export const ApiTokenOmniChange = createAction(
  '[OMNI CONFIGURATION]: API Token Omni Changed',
  props<{ apiTokenOmni: string }>(),
);

export const NotificationEmailOmniChange = createAction(
  '[OMNI CONFIGURATION]: Notification Email Omni Changed',
  props<{ notificationEmailOmni: string }>(),
);

export const LookBackDaysOmniChange = createAction(
  '[OMNI CONFIGURATION]: Look Back Days Omni Changed',
  props<{ lookBackDaysOmni: number | null }>(),
);

export const SaveOmniConfiguration = createAction('[OMNI CONFIGURATION]: Save Omni Configuration');

export const SaveOmniConfigurationSuccess = createAction(
  '[OMNI CONFIGURATION]: Save Omni Configuration Success',
  props<{ res: any }>(),
);

export const SaveOmniConfigurationFailed = createAction(
  '[OMNI CONFIGURATION]: Save Omni Configuration Failed',
  props<{ error: any }>(),
);

export const UpdateOmniConfiguration = createAction('[OMNI CONFIGURATION]: Update Omni Configuration');

export const UpdateOmniConfigurationSuccess = createAction(
  '[OMNI CONFIGURATION]: Update Omni Configuration Success',
  props<{ res: any }>(),
);

export const UpdateOmniConfigurationFailed = createAction(
  '[OMNI CONFIGURATION]: Update Omni Configuration Failed',
  props<{ error: any }>(),
);

export const ToggleIntegrationConfHelpTextStatus = createAction(
  '[OMNI CONFIGURATION]: Toggle Integration Configuration Help Text Status',
);

export const ToggleCredentialsConfHelpTextStatus = createAction(
  '[OMNI CONFIGURATION]: Toggle Credentials Configuration Help Text Status',
);

export const ToggleNotificationHelpTextStatus = createAction(
  '[OMNI CONFIGURATION]: Toggle Notification Help Text Status',
);

export const ToggleCampaignReportingHelpTextStatus = createAction(
  '[OMNI CONFIGURATION]: Toggle Campaign Reporting Help Text Status',
);

export const EditOmniIntegrationSystem = createAction(
  '[OMNI CONFIGURATION]: Edit Omni Integration System',
  props<{ omniData: any }>(),
);

export const CloseOmniEditIntegration = createAction('[OMNI CONFIGURATION]: Close Omni Edit Integration');

export const OmniSubmitData = createAction('[OMNI CONFIGURATION]: Omni Submit Data');
